import type { Listing } from '@thevillages/schemas';

import { Component, input } from '@angular/core';

import { ListingDetailsAccordion } from '../accordion/accordion';

@Component({
  imports: [ListingDetailsAccordion],
  selector: 'app-listing-details-village-details',
  templateUrl: './village-details.html',
})
export class ListingDetailsVillageDetails {
  public readonly listing = input.required<Listing>();
}
